import React, { useEffect } from 'react';
import { useAppContext } from '../context';
import { useNavigate } from 'react-router-dom';
import MainHeader from '../components/MainHeader';
import SiteLoading from '../views/SiteLoading';
import MainFooter from '../components/MainFooter';

/**
 * MainLayout component:
 * standar main layout component for the application controling authorization
 * and page level access control, global loading screena, and redirections.
 */
export default function MainLayout({ children, isForAuth }) {
  const { user, siteLoadingEnabled, setSiteLoadingEnabled } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!siteLoadingEnabled) {
      if (isForAuth && !user) {
        navigate('/login');
      }
      if (!isForAuth && user) {
        navigate('/');
      }
    }
  }, [user, siteLoadingEnabled, isForAuth]);

  return siteLoadingEnabled ? (
    <SiteLoading />
  ) : isForAuth ? (
    <div>
      <MainHeader />
      {children}
      <MainFooter />
    </div>
  ) : (
    <div>{children}</div>
  );
}
